import { CloudflareAsset } from "@/shared/common/enums";
import { config } from "app/config";

const baseUrl = config.cloudflareAssetsBaseUrl;
const businessBaseUrl = `${baseUrl}/Business`;

export default {
  [CloudflareAsset.ARE]: `${baseUrl}/Countries/are.svg`,
  [CloudflareAsset.ARM]: `${baseUrl}/Countries/arm.svg`,
  [CloudflareAsset.AUS]: `${baseUrl}/Countries/aus.svg`,
  [CloudflareAsset.CAN]: `${baseUrl}/Countries/can.svg`,
  [CloudflareAsset.CHE]: `${baseUrl}/Countries/che.svg`,
  [CloudflareAsset.CHN]: `${baseUrl}/Countries/chn.svg`,
  [CloudflareAsset.EUR]: `${baseUrl}/Countries/eur.svg`,
  [CloudflareAsset.GBR]: `${baseUrl}/Countries/gbr.svg`,
  [CloudflareAsset.GEL]: `${baseUrl}/Countries/gel.svg`,
  [CloudflareAsset.IND]: `${baseUrl}/Countries/ind.svg`,
  [CloudflareAsset.JPN]: `${baseUrl}/Countries/jpn.svg`,
  [CloudflareAsset.KOR]: `${baseUrl}/Countries/kor.svg`,
  [CloudflareAsset.RUS]: `${baseUrl}/Countries/rus.svg`,
  [CloudflareAsset.SWE]: `${baseUrl}/Countries/swe.svg`,
  [CloudflareAsset.USA]: `${baseUrl}/Countries/usa.svg`,
  [CloudflareAsset.XAU]: `${baseUrl}/Countries/xau.svg`,
  [CloudflareAsset.Account]: `${baseUrl}/AccountTypes/ACCOUNT.svg`,
  [CloudflareAsset.AccountDisabled]: `${baseUrl}/AccountTypes/ACCOUNT_DISABLED.svg`,
  [CloudflareAsset.Sign]: `${businessBaseUrl}/assets/icon.sign.svg`,
  [CloudflareAsset.Add]: `${businessBaseUrl}/assets/icon.add.svg`,
  [CloudflareAsset.AddLight]: `${businessBaseUrl}/assets/Icon.add.white.svg`,
  [CloudflareAsset.SignLight]: `${businessBaseUrl}/assets/icon.sign.light.svg`,
  [CloudflareAsset.Save]: `${businessBaseUrl}/assets/icon.save.svg`,
  [CloudflareAsset.Edit]: `${businessBaseUrl}/assets/icon.edit.svg`,
  [CloudflareAsset.Hamburger]: `${businessBaseUrl}/assets/icon.hamburger.svg`,
  [CloudflareAsset.Info]: `${businessBaseUrl}/assets/icon.info.svg`,
  [CloudflareAsset.EyeOpen]: `${businessBaseUrl}/assets/icon.eye.open.svg`,
  [CloudflareAsset.EyeClose]: `${businessBaseUrl}/assets/icon.eye.close.svg`,
  [CloudflareAsset.EyeOpenLight]: `${businessBaseUrl}/assets/icon.eye.open.light.svg`,
  [CloudflareAsset.EyeCloseLight]: `${businessBaseUrl}/assets/icon.eye.close.light.svg`,
  [CloudflareAsset.Refresh]: `${businessBaseUrl}/assets/icon.refresh.svg`,
  [CloudflareAsset.ArrowShortLeft]: `${businessBaseUrl}/assets/icon.arrow.short.left.svg`,
  [CloudflareAsset.ArrowShortRight]: `${businessBaseUrl}/assets/icon.arrow.short.right.svg`,
  [CloudflareAsset.ArrowShortUp]: `${businessBaseUrl}/assets/icon.arrow.short.up.svg`,
  [CloudflareAsset.ArrowShortDown]: `${businessBaseUrl}/assets/icon.arrow.short.down.svg`,
  [CloudflareAsset.ArrowLongLeft]: `${businessBaseUrl}/assets/icon.arrow.long.left.svg`,
  [CloudflareAsset.ArrowShortDownLight]: `${businessBaseUrl}/assets/icon.arrow.short.down.light.svg`,
  [CloudflareAsset.ArrowShortDownQuaternary]: `${businessBaseUrl}/assets/icon.arrow.short.down.quaternary.svg`,
  [CloudflareAsset.ArrowShortUpLight]: `${businessBaseUrl}/assets/icon.arrow.short.up.light.svg`,
  [CloudflareAsset.ArrowShortUpQuaternary]: `${businessBaseUrl}/assets/icon.arrow.short.up.quaternary.svg`,
  [CloudflareAsset.MyAmeriaLogo]: `${businessBaseUrl}/assets/icon.myameria.logo.svg`,
  [CloudflareAsset.History]: `${businessBaseUrl}/assets/icon.history.svg`,
  [CloudflareAsset.Card]: `${businessBaseUrl}/assets/icon.card.svg`,
  [CloudflareAsset.Main]: `${businessBaseUrl}/assets/icon.main.svg`,
  [CloudflareAsset.Transfer]: `${businessBaseUrl}/assets/icon.transfer.svg`,
  [CloudflareAsset.Loan]: `${businessBaseUrl}/assets/icon.loan.svg`,
  [CloudflareAsset.LoanDangerLight]: `${businessBaseUrl}/assets/icon.loan.danger.light.svg`,
  [CloudflareAsset.DocumentList]: `${businessBaseUrl}/assets/icon.document.list.svg`,
  [CloudflareAsset.DocumentDeclaration]: `${businessBaseUrl}/assets/icon.document.declaration.svg`,
  [CloudflareAsset.Warning]: `${businessBaseUrl}/assets/icon.warning.svg`,
  [CloudflareAsset.OwnAccountTransfer]: `${businessBaseUrl}/assets/icon.transfer.between.accounts.svg`,
  [CloudflareAsset.AccountTransfer]: `${businessBaseUrl}/assets/icon.transfer.account.svg`,
  [CloudflareAsset.InternationalTransfer]: `${businessBaseUrl}/assets/icon.transfer.international.svg`,
  [CloudflareAsset.CurrencyExchange]: `${businessBaseUrl}/assets/icon.transfer.currency.exchange.svg`,
  [CloudflareAsset.CurrencyExchangeArrows]: `${businessBaseUrl}/assets/icon.currency.exchange.svg`,
  [CloudflareAsset.Currencies]: `${businessBaseUrl}/assets/icon.currencies.svg`,
  [CloudflareAsset.BudgetTransfer]: `${businessBaseUrl}/assets/icon.transfer.budget.svg`,
  [CloudflareAsset.CardTransfer]: `${businessBaseUrl}/assets/icon.transfer.card.svg`,
  [CloudflareAsset.GroupTransfer]: `${businessBaseUrl}/assets/icon.transfer.group.svg`,
  [CloudflareAsset.SelectedOption]: `${businessBaseUrl}/assets/icon.selectedOption.svg`,
  [CloudflareAsset.Trash]: `${businessBaseUrl}/assets/icon.trash.svg`,
  [CloudflareAsset.Star]: `${businessBaseUrl}/assets/icon.star.svg`,
  [CloudflareAsset.AccountOpeningApplication]: `${businessBaseUrl}/assets/icon.account.opening.svg`,
  [CloudflareAsset.AccountClosureApplication]: `${businessBaseUrl}/assets/icon.account.closure.svg`,
  [CloudflareAsset.Application]: `${businessBaseUrl}/assets/icon.application.svg`,
  [CloudflareAsset.PhoneBankingApplication]: `${businessBaseUrl}/assets/icon.phone.banking.svg`,
  [CloudflareAsset.PayrollCardOpeningApplication]: `${businessBaseUrl}/assets/icon.payroll.card.opening.svg`,
  [CloudflareAsset.PeriodicalPaymentsApplication]: `${businessBaseUrl}/assets/icon.periodical.payments.svg`,
  [CloudflareAsset.CardServiceInstructionApplication]: `${businessBaseUrl}/assets/icon.payment.card.service.instruction.svg`,
  [CloudflareAsset.LoanTrancheDisbursementApplication]: `${businessBaseUrl}/assets/icon.loan.tranche.disbursement.svg`,
  [CloudflareAsset.UserOpeningApplication]: `${businessBaseUrl}/assets/icon.user.opening.svg`,
  [CloudflareAsset.DepositTerminationApplication]: `${businessBaseUrl}/assets/icon.deposit.termination.svg`,
  [CloudflareAsset.ClassicCard]: `${businessBaseUrl}/cards/card.classic.svg`,
  [CloudflareAsset.PlatinumCard]: `${businessBaseUrl}/cards/card.platinum.svg`,
  [CloudflareAsset.DefaultCard]: `${businessBaseUrl}/cards/card.default.svg`,
  [CloudflareAsset.Visa]: `${businessBaseUrl}/assets/icon.visa.svg`,
  [CloudflareAsset.VisaSmall]: `${businessBaseUrl}/assets/icon.visa.small.svg`,
  [CloudflareAsset.MasterCard]: `${businessBaseUrl}/assets/icon.master.svg`,
  [CloudflareAsset.MasterCardSmall]: `${businessBaseUrl}/assets/icon.master.small.svg`,
  [CloudflareAsset.ArCa]: `${businessBaseUrl}/assets/icon.arca.svg`,
  [CloudflareAsset.ArCaSmall]: `${businessBaseUrl}/assets/icon.arca.small.svg`,
  [CloudflareAsset.QRScanner]: `${businessBaseUrl}/assets/icon.qr.scanner.svg`,
  [CloudflareAsset.EmptyContent]: `${businessBaseUrl}/assets/icon.empty.content.svg`,
  [CloudflareAsset.Error]: `${businessBaseUrl}/assets/icon.error.svg`,
  [CloudflareAsset.Calendar]: `${businessBaseUrl}/assets/icon.calendar.svg`,
  [CloudflareAsset.LoanRepayment]: `${businessBaseUrl}/assets/icon.loan.svg`,
  [CloudflareAsset.TopUp]: `${businessBaseUrl}/assets/icon.top.up.svg`,
  [CloudflareAsset.Rename]: `${businessBaseUrl}/assets/icon.rename.svg`,
  [CloudflareAsset.StopLight]: `${businessBaseUrl}/assets/icon.stop.light.svg`,
  [CloudflareAsset.Beneficiaries]: `${businessBaseUrl}/assets/icon.beneficiaries.svg`,
  [CloudflareAsset.AddGrey]: `${businessBaseUrl}/assets/icon.add.grey.svg`,
  [CloudflareAsset.Search]: `${businessBaseUrl}/assets/icon.search.svg`,
  [CloudflareAsset.ProfileGroupGreen]: `${businessBaseUrl}/assets/icon.profile.group.green.svg`,
};
